import React from 'react'
import { Link } from 'gatsby'
import Button from '../Button/button.js'
import Clock from '../Clock/clock.js'

import './footer.css'

class Footer extends React.Component {
  render() {
    return (
      <footer>
            <div className="container">
                {/* TOP */}
                <div className="footer-top"></div>

                {/* MIDDLE */}
                { this.props.isPublic || this.props.isHomePage ? 
                  <div className="footer-middle">
                     <Button size="tiny" to="/portfolio/" inlineicon="right"><span>📁</span> Portfolio</Button>
                     <Button size="tiny" to="/about/" inlineicon="right"><span>👤</span> About</Button>
                     <Button size="tiny" external="true" href="/contact/" inlineicon="right"><span>✉️</span> Contact</Button>
                  </div> 
                  : 
                  <div className="footer-middle">
                     <Button size="tiny" to="/portfolio/" inlineicon="right"><span>📁</span> Portfolio</Button>
                     <Button size="tiny" to="/about/" inlineicon="right"><span>👤</span> About</Button>
                     <Button size="tiny" to="/notes/" inlineicon="right"><span>📝</span> Notes</Button>
                     <Button size="tiny" external="true" href="/contact/" inlineicon="right"><span>✉️</span> Contact</Button>
                  </div> 
                }

                {/* BOTTOM */}
                <div className="footer-bottom">
                  <div className="legal">&copy; 2019-{new Date().getFullYear()} jeffrey wolff</div>
                  { this.props.isHomePage ? 
                  <div className="menu">
                    <Link to="#" className="icon-link" title=" . "><Clock></Clock></Link>
                  </div> : '' }
                  { this.props.isPublic || this.props.isHomePage ? '' : 
                  <div className="menu">
                    <a href="//linkedin.com/in/jeffreywolff1/" target="_blank" className="icon-link" aria-label="LinkedIn">in</a>
                    <a href="//last.fm/user/jeffwolff" target="_blank" className="icon-link" aria-label="Last.fm">lfm</a>
                    <Link to="/notes/time-machine/" className="icon-link" title="Past Website Versions">⏪</Link>
                  </div> }
                </div>

            </div>
      </footer>
    )}
  }
  export default Footer
